<div [loading]="loading">
  <a [routerLink]="route.parse('product', [product.ident])" [queryParams]="getQueryParam(product | getPrices:0)" title="En savoir plus" class="product-img">
    <span class="img-container">
      <img [src]="getImage(indImg)" [alt]="product.name"/>
    </span>

    <div class="bandeau-rupture" *ngIf="!canOrder(product)">
      Rupture
    </div>

    <span class="banner-container">
      <gob-banner [banners]="product.banners"></gob-banner>
    </span>

    <span *ngIf="product.isUsed" class="stamp-container">
      <gob-stamp></gob-stamp>
    </span>
  </a>

  <div class="products-price-container">
    <a href="" [routerLink]="route.parse('product', [product.ident])" [queryParams]="getQueryParam(product | getPrices:0)" title="En savoir plus" class="product-title">
      {{product.name}}
    </a>
    <a href="" [routerLink]="route.parse('product', [product.ident])" [queryParams]="getQueryParam(product | getPrices:0)" title="En savoir plus" class="subtitle truncate-2l">
      {{product.subtitle}}
    </a>
    <span class="product-stars">
      <gob-stars [stars]="product.stars"></gob-stars>
    </span>
    <span *ngIf="product | getPrices:0" class="product-price">
      <span class="price-discounted" *ngIf="(product | getPrices:0)?.discounted">{{product | getPrices:0 | formatPrice:true}}€</span>
      {{product | getPrices:0 | formatPrice}}€

      <span *ngIf="canOrder(product) && !orderOnlineOnly(product)">
        <a (click)="addCart(product)"><i class="fa-regular fa-cart-shopping-fast"></i></a>
      </span>

      <span *ngIf="!canOrder(product)" class="rupture-bell">
        <a (click)="openAlertModal()"><i class="fa-regular fa-bell"></i></a>
      </span>

      <span *ngIf="orderOnlineOnly(product)" class="instore">Uniquement en boutique</span>
    </span>
  </div>
</div>

<gob-alert-modal
  [isOpen]="isAlertOpen"
  [productName]="product.name"
  [productId]="product.ident"
  (closeEvent)="isAlertOpen = false">
</gob-alert-modal>
